export const strings = {
  title: 'İşler',
  view: 'Zaten Görüntülendi',
  apply: 'Uygulamak',
  recommendedJobs: 'Önerilen İşler',
  allRecommmendation: 'Tüm Öneriler',
  my_speciality: 'Benim Uzmanlık Alanım',
  speciality: 'Uzmanlık',
  summary: 'Özet',
  edit: 'Düzenlemek',
  job: 'İş',
  url: 'Kaynak (İsteğe bağlı)',
  serachJob: 'İş Ara',
  no_recommendation: 'Öneri yok',
  no_recommendation_message: 'Profilinize uygun herhangi bir iş bulamadık',
  shareJobDetails: 'İş Detaylarını Paylaşın',
  warning: 'Bunu bir daha gösterme',
  similar: 'Benzer İşler',
  job_description: 'İş Tanımı',
  cover_image: 'Kapak Resmi',
  job_title: 'İş Ünvanı',
  company_name: 'Şirket Adı',
  title_placeholder: 'Başlığı girin',
  company_placeholder: 'Şirket Adını Girin',
  url_placeholder: 'URL bağlantısını buraya yapıştırın',
  publish: 'Yayımlandı',
  published: 'Yayımla',
  delete_job: 'İşi Sil',
  discard_changes: 'Tamam',
  save_job_confirm: 'Silmek istediğinizden emin misiniz?',
  save_job_confirm_para: 'Kayıt listeden silinecek',
  errors: {
    cover_required: 'Kapak resmini yüklemeniz gerekiyor',
    title_required: 'İş Ünvanı gereklidir',
    company_min_length: 'Şirket Adı en az 3 karakter olmalıdır',
    company_max_length: 'Şirket Adı 250 karakterden fazla olamaz',
    company_required: 'Şirket Adı gereklidir',
    url_required: "İş URL'si gereklidir",
    country_required: 'Ülke gereklidir',
    title_min_length: 'Meslek ünvanı en az 3 karakter olmalıdır',
    title_max_length: 'Meslek ünvanı 250 karakterden uzun olamaz',
    brief_required: 'İş Özeti gereklidir',
    brief_min_length: 'İş Özeti en az 3 karakter olmalıdır',
    brief_max_length: 'İş Özeti 250 karakterden uzun olamaz',
    duration_number: 'Zaman her zaman bir sayı olmalıdır',
    duration_min: 'Zaman sıfırdan büyük olmalıdır',
    duration_max: "Zaman 1000'den büyük olmamalıdır",
    url: 'Kaynak geçerli bir URL olmalıdır',
    url_max_limit: 'Kaynak 300 karakterden uzun olamaz',
    description_required: 'İş tanımı gereklidir',
    description_min_length: 'İş tanımı en az 3 karakter olmalıdır',
    description_max_length: 'İş tanımı 2500 karakterden fazla olamaz',
    speciality_id_required: 'Lütfen bir uzmanlık alanı seçin',
    country_id_required: 'Lütfen bir ülke seçin',
    cover_uploading: 'Kapak yükleniyor',
  },
};
